import { Layers } from "appworks/graphics/layers/layers";
import { AbstractControl } from "appworks/ui/controls/abstract-control";
import { GameNameLabelControl } from "appworks/ui/controls/standard/text/game-name-label-control";
import { TimeControl } from "appworks/ui/controls/standard/text/time-control";
import { ControlFactory } from "../control-factory";

export class TimeControlFactory implements ControlFactory {
    public filter(layer: Layers): boolean {
        if (layer.getFlexiText("time")) {
            return true;
        }
        return false;
    }

    public build(layer: Layers): AbstractControl[] {
        return [ new TimeControl(layer.getFlexiText("time")) ];
    }
}
